/** Parses `yyyy-MM-dd` as a local calendar date, so date comparisons do not shift across time zones. */
export function parseLocalDate(value: unknown): Date {
  if (typeof value === 'string') {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (match) {
      return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    }
  }
  return new Date(value as string | number | Date);
}
